
import React, { useEffect, useRef, useState } from 'react';
import { Button, Dropdown, Flex, Tooltip } from 'antd';
import { BellIcon, ExitIcon, FilledStar, MenuIcon, StarIcon } from '../../assets/icons';
import MuteIcon from '../../assets/icons/Mute';
import CustomAvatar from '../../Components/CustomAvatar';
import UserStatusBadge from '../../Components/UserStatusBadge';
import { useNavigate, useParams } from 'react-router';
import { API_ENDPOINTS } from '../../API/endpoints';
import ApiService from '../../API/apiService';
import { handleApiError, localStorageUtil } from '../../utils/CommonFunctions';
import { useBridgeStore } from '../../store/apis/useBridgeStore';
import { useUserSelfStore } from '../../store/apis/useUserStore';

const DirectMessageListItem = ({ item, getFavListApi, getChatListApi, hideMoreOptions = false, isFavoriteList = false }) => {
  const navigate = useNavigate();
  const { name } = useParams();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  // const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const userData = useUserSelfStore((state) => state.userSelfData)
  const [isFavorite, setIsFavorite] = useState(item?.isFavorite || false);
  const [loading, setLoading] = useState(false);
  const [isMuted, setIsMuted] = useState(userData?.muteUsers?.includes(item?._id));
  const triggerHeaderRefresh = useBridgeStore((state) => state.triggerHeaderRefresh);
  const triggerSidebarRefresh = useBridgeStore((state) => state.triggerSidebarRefresh);
  const triggerDraftRefresh =  useBridgeStore(store => store.triggerDraftRefresh)

  const checkMuteStatus = (item) => {
    const userData = localStorageUtil.getItem("userData");
    const isMuted =
      userData?.muteUsers?.includes(item?._id) || false;
    setIsMuted(isMuted);
  };

  useEffect(() => {
    checkMuteStatus(item);
  }, [item])

  const handleMuteStatusChange = async (id, isMuted) => {
    isMuted ? handleUnMuteUserApi(id) : handleMuteUserApi(id);
  };

  const handleMuteUserApi = async (id) => {
    const reqBody = { userId: id };
    try {
      const response = await ApiService.post(
        API_ENDPOINTS.muteUser,
        reqBody
      );
      if (response?.status === 1) {
        // userData.muteUsers = response.data.muteUsers;
        // localStorage.setItem('userData', JSON.stringify(userData));
        const existingUserData = JSON.parse(localStorage.getItem('userData')) || {};
  const updatedUserData = {
    ...existingUserData,
    muteUsers: response.data.muteUsers
  };
  localStorage.setItem('userData', JSON.stringify(updatedUserData));
        setIsMuted(true);
        triggerHeaderRefresh(Date.now());
        triggerSidebarRefresh(Date.now(), 'chat');
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleUnMuteUserApi = async (id) => {
    const reqBody = { userId: id };
    try {
      const response = await ApiService.post(
        API_ENDPOINTS.unmuteUser,
        reqBody
      );
      if (response?.status === 1 && response?.data) {
        // userData.muteUsers = response.data.muteUsers;
        // localStorage.setItem('userData', JSON.stringify(userData));
        const existingUserData = JSON.parse(localStorage.getItem('userData')) || {};
  const updatedUserData = {
    ...existingUserData,
    muteUsers: response.data.muteUsers
  };
  localStorage.setItem('userData', JSON.stringify(updatedUserData));
        setIsMuted(false);
        triggerHeaderRefresh(Date.now());
        triggerSidebarRefresh(Date.now(), 'chat');
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const toggleReadStatus = async (id, isUnread) => {
    setLoading(true);
    try {
      const endpoint = isUnread
        ? `${API_ENDPOINTS.messageSeenChat}/${id}`
        : `${API_ENDPOINTS.unreadMessage}/${id}`;
      const method = isUnread ? 'put' : 'put';

      const response = await ApiService[method](endpoint);

      if (response?.data && response?.status === 1) {
        if (isFavoriteList) {
          await getFavListApi();
        } else {
          await getChatListApi();
        }
        triggerHeaderRefresh(Date.now(), 'favorite');
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  const closeConversationApi = async (id) => {
    setLoading(true);
    const reqBody = {
      userId: userData?._id,
      conversationUserId: id,
    };
    if (item?.isFavorite) {
      reqBody.fav = true;
    }
    try {
      const response = await ApiService.post(
        API_ENDPOINTS.closeConversation,
        reqBody
      );
      if (response?.data && response?.status === 1) {
        setLoading(false);
        setDropdownOpen(false);
        const UserData = JSON.parse(localStorage.getItem("userData"));
        let rout=UserData?.domain || 'elsnertech'

        // Clear last active to avoid redirecting back to closed conversation
        UserData.lastActiveChat = null;
        localStorage.setItem("userData", JSON.stringify(UserData));
        localStorage.setItem("current_id", "");
        navigate(`/${rout}/welcome`);

        if (isFavorite) {
          await Promise.all([getChatListApi(), getFavListApi()]);
        } else {
          await getChatListApi();
        }
        localStorageUtil.removeItem(`draft-${id}`);
        triggerDraftRefresh(Date.now())
        triggerHeaderRefresh(Date.now(), 'favorite');
      } else {
        setDropdownOpen(false);
      }
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  };

  const handleFav = async (id) => {
    setLoading(true);
    try {
      const reqBody = {
        userId: userData?._id,
        favoriteUserId: id,
      };

      const response = await ApiService.post(
        API_ENDPOINTS.addFavoriteChat,
        reqBody
      );

      if (response?.data && response?.status === 1) {
        setIsFavorite(true);
        await Promise.all([
          getChatListApi(),
          getFavListApi()
        ]);
        triggerHeaderRefresh(Date.now(), 'favorite');
      }
    } catch (error) {
      setIsFavorite(false);
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleUnFav = async (id) => {
    setLoading(true);
    try {
      const reqBody = {
        userId: userData?._id,
        favoriteUserId: id,
      };

      const response = await ApiService.post(
        API_ENDPOINTS.removeFavoriteChat,
        reqBody
      );

      if (response?.data && response?.status === 1) {
        setIsFavorite(false);
        await Promise.all([
          getChatListApi(),
          getFavListApi(),
        ]);
        triggerHeaderRefresh(Date.now(), 'favorite');
      }
    } catch (error) {
      setIsFavorite(false)
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };
  if (!item) {
    return null;
  }

  const menuItems = [
    {
      key: 'sidebarDirectChatddItem-1',
      label: item?.unseenMessagesCount > 0 ? 'Mark as read' : 'Mark as unread',
      icon: <MenuIcon />,
      onClick: () => {
        toggleReadStatus(item?._id, item?.unseenMessagesCount > 0);
        setDropdownOpen(false);
      },
    },
    {
      key: 'sidebarDirectChatddItem-2',
      label: isFavorite ? 'Unfavorite' : 'Favorite',
      icon: isFavorite ? <FilledStar /> : <StarIcon />,
      onClick: async () => {
        try {
          if (isFavorite) {
            handleUnFav(item._id);
          } else {
            handleFav(item._id);
          }
          setDropdownOpen(false);
        } catch (error) {
          handleApiError(error);
        }
      },
    },
    {
      key: 'sidebarDirectChatddItem-3',
      onClick: () => handleMuteStatusChange(item?._id, isMuted),
      label: isMuted ? 'Unmute Conversation' : 'Mute Conversation',
      icon: isMuted ? <MuteIcon /> : <BellIcon />,
    },
    { type: 'divider' },
    {
      key: 'sidebarDirectChatddItem-5',
      label: <div className="text-danger">Close Conversation</div>,
      icon: <ExitIcon />,
      onClick: () => {
        closeConversationApi(item?._id);
      },
    },
  ];

  const isSelected = name === item._id;

  return (
    <Flex
      justify="flex-start"
      align="center"
      gap="10px"
      className={isMuted ? 'sidebar-mute' : ''}
      role="button"
      tabIndex="0"
    >
      <div className="msg-wrapper">
        <div className="avatar-badge-wrapper">
          <CustomAvatar
            size={25}
            img={
              item?._id === userData?._id
                ? userData?.thumbnailAvatarUrl
                : item?.thumbnailAvatarUrl
            }
            userName={item?.userName}
          />
          <UserStatusBadge
            status={
              item?._id === userData?._id
                ? userData?.status
                : item?.status
            }
            showStatus={false}
            font_size="11px"
          />
        </div>
        <span className="sider-name-icon-wrapper">
          <Tooltip
            arrowiselected={isSelected}
            arrow={{ pointAtCenter: true }}
            placement="top"
            title={
              item?.userName && item?.userName?.length > 8
                ? item?.userName === userData?.userName
                  ? `${userData?.userName || ''} (you)`
                  : item?.userName
                : null
            }
            className={`${item?.unseenMessagesCount > 0
              ? 'name sidebarNameStatusIcon highlight'
              : 'name sidebarNameStatusIcon'
              }`}
            style={
              item?.unseenMessagesCount > 0
                ? { fontWeight: 'bold', color: '#FFFFFF' }
                : {}
            }
          >
            {item?.userName === userData?.userName
              ? `${(userData?.userName || '').length < 20
                ? userData?.userName
                : `${(userData?.userName || '').slice(0, 8)}...`} (you)`
              : (item?.userName || '').length < 20
                ? item?.userName
                : `${(item?.userName || '').slice(0, 12)}...`}{' '}
          </Tooltip>
          {item?._id === userData?._id ?
            userData?.customStatusEmoji && (
              <Tooltip placement="top" title={userData?.customStatus} arrow={false}>
                <img
                  className="search-icon"
                  width={15}
                  height={15}
                  src={userData?.customStatusEmoji}
                />
              </Tooltip>
            ) : item?.customStatusEmoji && (
              <Tooltip placement="top" title={item?.customStatus} arrow={false}>
                <img
                  className="search-icon"
                  width={15}
                  height={15}
                  src={item?.customStatusEmoji}
                />
              </Tooltip>
            )}
        </span>
      </div>
      {!hideMoreOptions && (
        <>
          <span className="unread-msg-count">
            {item?.unseenMessagesCount > 0 ? item?.unseenMessagesCount : ''}
          </span>
          <div className="mute-icon-wrapper" onClick={(e) => e.stopPropagation()}>
            {isMuted && <MuteIcon />}
            <Dropdown
              onOpenChange={setDropdownOpen}
              menu={{ items: menuItems }}
              className="ec-dropdown sidebar-directchat-dropdown"
              dropdownRender={(menu) => (
                <div className="ec-dropdown__menu sidebar-directchat-dropdown__menu">{menu}</div>
              )}
              trigger={['click']}
            >
              <Button
                type="text"
                className="options-menu-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  setDropdownOpen(true);
                }}
              >
                <i className="fa-solid fa-ellipsis-vertical"></i>
              </Button>
            </Dropdown>
          </div>
        </>
      )}
    </Flex>
  );
};

export default DirectMessageListItem;